<template>
  <SelectComponent
    v-model="localModelValue"
    :values="orderItem"
    :searchable="searchable"
    :label="label"
    :track-by="trackBy"
    :disabled="disabled"
    :required="required"
    :errors="errors"
    :name="name"
    :placeholder="placeholder"
    :edition-mode="editionMode"
    :label-class="labelClass"
    :select-class="selectClass"
    :is-grouped="isGrouped"
    :none-selected-label="noneSelectedLabel"
  />
</template>

<script>
import SelectComponent from '@c/BaseFormComponent/SelectComponent.vue'

export default {
  name: 'BaseShowEditSelectSimple',
  components: {
    SelectComponent
  },
  props: {
    editionMode: {
      type: Boolean,
      default: true
    },
    modelValue: {
      type: String,
      default: '',
      require: true
    },
    trackBy: {
      type: String,
      required: false,
      default: 'id'
    },
    attributeLabel: {
      type: String,
      required: false,
      default: 'name'
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false,
      default: null
    },
    groupClass: {
      type: String,
      required: false,
      default: ''
    },
    labelClass: {
      type: String,
      required: false,
      default: ''
    },
    selectClass: {
      type: String,
      required: false,
      default: ''
    },
    errors: {
      type: Object,
      required: false,
      default() {
        return {}
      }
    },
    options: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    showPointer: {
      type: Boolean,
      required: false,
      default: true
    },
    hideSelected: {
      type: Boolean,
      required: false,
      default: false
    },
    searchable: {
      type: Boolean,
      required: false,
      default: false
    },
    canTrackByBeNull: {
      type: Boolean,
      required: false,
      default: true
    },
    order: {
      type: Boolean,
      required: false,
      default: true
    },
    isGrouped: {
      type: Boolean,
      required: false,
      default: false
    },
    noneSelectedLabel: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['update:modelValue', 'change'],
  computed: {
    localModelValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
        this.$emit('change', value)
      }
    },
    orderItem() {
      if (this.order) {
        return this.options.sort((a, b) => a.name.localeCompare(b.name))
      }
      return this.options
    }
  }
}
</script>
